module.exports = __webpack_public_path__ + "static/media/products-3.5b684c92.svg";